import {Component} from "react";
import FilterSwatch from "./FilterSwatch";
import DrawerSpinner from "../DrawerSpinner";
import FilterCheckbox from "./FilterCheckbox";

export default class FilterDrawer extends Component<any, any> {

  state = {
    sizeFilterAlpha: [],
    sizeFilterNumeric: [],
    brandFilter: [],
    is_filtering: false
  }

  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    (async() => {
      const response = await (await fetch('?view=filter')).json();
      let sizeArray = response.find((item: any) => item.label.toLowerCase() === 'taille' || item.label.toLowerCase() === 'size');
      let brandArray = response.find((item: any) => item.label.toLowerCase() === 'marque' || item.label.toLowerCase() === 'brand');

      let sizes = sizeArray.values;
      let brands = brandArray.values.filter((item: any) => item !== 'BLANK');

      // Get only the sizes that are available string
      let sizesAlpha = sizes.filter((item: any) => isNaN(parseInt(item)));
      let sizesNumeric = sizes.filter((item: any) => !isNaN(parseInt(item)));

      this.setState({
        sizeFilterAlpha: sizesAlpha,
        sizeFilterNumeric: sizesNumeric,
        brandFilter: brands
      });
    })();
  }

  clearChoice = (choice: string) => {
    let selectedChoices = document.querySelectorAll(`[name="${choice}"][data-checked="true"]`);
    selectedChoices.forEach((choice: any) => {
      choice.click();
    });
  }

  filterProducts = async() => {
    this.setState({is_filtering: true});
    this.forceUpdate();
    setTimeout(async() => {
      await window.filterProducts();
      this.setState({is_filtering: false});
      window.closeFilterDrawer();
    }, 500);
  }

  render() {
    return(
      <div data-open={this.props.open} className={'filter-drawer-wrapper'}>
        <div className={'filter-drawer'}>
          <div className={'filter-header'}>
            {window.currLanguage === 'fr' ? 'FILTRER' : 'FILTER'}
            <button className={'close-button'} onClick={window.closeFilterDrawer}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M19.2803 4.71967C19.5732 5.01256 19.5732 5.48744 19.2803 5.78033L5.78033 19.2803C5.48744 19.5732 5.01256 19.5732 4.71967 19.2803C4.42678 18.9874 4.42678 18.5126 4.71967 18.2197L18.2197 4.71967C18.5126 4.42678 18.9874 4.42678 19.2803 4.71967Z" fill="#414143"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M4.71967 4.71967C5.01256 4.42678 5.48744 4.42678 5.78033 4.71967L19.2803 18.2197C19.5732 18.5126 19.5732 18.9874 19.2803 19.2803C18.9874 19.5732 18.5126 19.5732 18.2197 19.2803L4.71967 5.78033C4.42678 5.48744 4.42678 5.01256 4.71967 4.71967Z" fill="#414143"/>
              </svg>
            </button>
          </div>
          <div className={'filter-body'}>
            {this.state.brandFilter.length > 0 &&
              (
                <div className={'filter'}>
                  <div className={'singular-filter-header'}>
                    <p>{window.currLanguage === 'fr' ? 'marque' : 'brand'}</p>
                    <button className={'clear-button'} onClick={() => this.clearChoice('marque')}>
                      {window.currLanguage === 'fr' ? 'Effacer' : 'Remove'}
                    </button>
                  </div>
                  <div className="choices" data-choice={'marque'}>
                    {this.state.brandFilter.map((size: any, index: number) =>
                      // @ts-ignore
                      <FilterCheckbox dataKey={index} name={'marque'} value={size} />
                    )}
                  </div>
                </div>
              )
            }
            <div className={'filter'}>
              <div className={'singular-filter-header'}>
                <p>{window.currLanguage === 'fr' ? 'taille' : 'size'}</p>
                <button className={'clear-button'} onClick={() => this.clearChoice('taille')}>
                  {window.currLanguage === 'fr' ? 'Effacer' : 'Remove'}
                </button>
              </div>
              <div className="choices" data-choice={'taille'}>
                {this.state.sizeFilterAlpha.map((size: any, index: number) =>
                  // @ts-ignore
                  <FilterSwatch dataKey={index} name={'taille'} value={size} />
                )}
              </div>
              <div className="choices" data-choice={'taille'}>
                {this.state.sizeFilterNumeric.map((size: any, index: number) =>
                  // @ts-ignore
                  <FilterSwatch dataKey={index} name={'taille'} value={size} />
                )}
              </div>
            </div>
          </div>
          <div className={'filter-footer'}>
            <button className={'apply-button'} onClick={this.filterProducts}>
              {this.state.is_filtering ? <DrawerSpinner /> : window.currLanguage === 'fr' ? 'Appliquer' : 'Apply'}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

